import { render, staticRenderFns } from "./HoldingCompany.vue?vue&type=template&id=3b8bd4cd"
import script from "./HoldingCompany.vue?vue&type=script&lang=ts"
export * from "./HoldingCompany.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports